// Copyright (c) 2017 Deere & Company

import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import DetailPanel from './detail-panel';
import {FormattedMessage} from 'react-intl';
import ReimbursementSummaryDetailsData from '../state/data';
import ReimbursementSummaryLeadAccount from '@deere/cps-it.warranty-model-factory/lib/reimbursement-summary-lead-account';
import ReportGrid from '../../../reports/shared/components/report-grid';
import ReportHeader from '../../../reports/shared/components/report-header';
import ReportHiddenColumns from '../../../reports/shared/components/report-columns';
import ReportLayout from '@deere/cps-it.warranty-model-factory/lib/report-layout';
import {getAgGridLocaleText} from '../../../shared/utils/ag-grid-locale-text';
import {getColumnDefinitions} from '../constants/column-definitions';
import {resizeReport} from '../../shared/services/resize-report';

const getTitle = showAllAccounts =>
    showAllAccounts ?
        'ALL_ACCOUNTS' :
        'DETAILS';

function handleGridApiDefinition(params) {

    const reportVariantParams = {
        isInitialLoad: this.isInitialLoad,
        layouts: this.layouts,
        selectedLayout: this.selectedLayout
    };

    this.actions.createAgGridApi(params.api, params.columnApi);

    this.actions.getReportLayouts('reimbursement-summary-details', params.columnApi, params.api, reportVariantParams);

}

function onColumnRemoved(columnEvent) {

    if (!columnEvent.visible) {

        this.actions.hideReportColumn(this.columnApi.getColumnState());

    }

}

class ReimbursementSummaryDetails extends Component {

    componentWillMount = () => {

        if (this.props.showAllAccounts) {

            this.props.actions.buildSummaryData(this.props.report);
            this.props.actions.resetSelectedLeadAccount();

        } else {

            this.props.actions.findRowData(this.props.report, this.props.queryParams.query);

        }

    };

    componentWillReceiveProps = nextProps => {

        if ((this.props.queryParams.query !== nextProps.queryParams.query) || (this.props.report !== nextProps.report)) {

            this.props.showAllAccounts ?
                this.props.actions.buildSummaryData(nextProps.report) :
                this.props.actions.findRowData(nextProps.report, nextProps.queryParams.query);

        }

    };

    componentDidUpdate = () => {

        if (this.props.data.rowData.length) {

            resizeReport();

        }

        if (this.props.selectedLayout && Object.keys(this.props.columnApi).length && this.props.isDefaultColumnStateAvailable) {

            this.props.columnApi.setColumnState(this.props.selectedLayout.columnState);
            this.props.gridApi.setSortModel(this.props.selectedLayout.sortModel);
            this.props.gridApi.setFilterModel(this.props.selectedLayout.filterModel);

        }

    };

    componentWillUnmount = () => {

        this.props.actions.resetReportVariant();

    };

    render = () => (

        <main className='reimbursement-summary-main'>
            <header className='reimbursement-summary-header'>
                <h2 className='header-title'>
                    <FormattedMessage
                        id={getTitle(this.props.showAllAccounts)}
                    />
                </h2>
            </header>
            {Object.keys(this.props.data.detail.data).length ?
                <DetailPanel
                    detail={this.props.data.detail}
                    queryParams={this.props.queryParams}
                /> :
                null
            }
            {this.props.isReportColumnsVisible && <ReportHiddenColumns/>}
            <ReportHeader
                columnApi={this.props.columnApi}
                gridApi={this.props.gridApi}
                reportName='reimbursement-summary-details'
            />
            <ReportGrid
                columnDefs={getColumnDefinitions(this.props.queryParams)}
                headerHeight={100}
                localeText={getAgGridLocaleText()}
                onColumnVisible={this.props::onColumnRemoved}
                onGridReady={this.props::handleGridApiDefinition}
                rowData={this.props.data.rowData}
            />
        </main>

    );

}

ReimbursementSummaryDetails.displayName = 'ReimbursementSummaryDetails';
ReimbursementSummaryDetails.propTypes = {
    actions: PropTypes.object.isRequired,
    columnApi: PropTypes.object.isRequired,
    data: PropTypes.instanceOf(ReimbursementSummaryDetailsData).isRequired,
    gridApi: PropTypes.object.isRequired,
    isDefaultColumnStateAvailable: PropTypes.bool.isRequired,
    isInitialLoad: PropTypes.bool.isRequired,
    isReportColumnsVisible: PropTypes.bool.isRequired,
    layouts: PropTypes.arrayOf(PropTypes.instanceOf(ReportLayout)).isRequired,
    queryParams: PropTypes.object.isRequired,
    report: PropTypes.arrayOf(PropTypes.instanceOf(ReimbursementSummaryLeadAccount)).isRequired,
    selectedLayout: PropTypes.instanceOf(ReportLayout),
    showAllAccounts: PropTypes.bool
};

export default ReimbursementSummaryDetails;



// WEBPACK FOOTER //
// ./src/reimbursement-summary/details/components/index.js